export const SectionOurMissionTranslationsEn = {
  'Our mission': 'Our mission',
  'First mission': 'It lies in changing your perception of your wardrobe.',
  'Second mission':
    'Satisfy the need for using and wearing an expensive wardrobe without the necessity to buy it, undoubtedly saving your money and not limiting the enjoyable emotions.',
  'Third mission':
    'Continuing the lifecycle of clothing has a significant positive impact on the environment. We know that society has begun to consider more conscious and ecological ways of consuming goods. Therefore, using existing garments instead of buying new ones contributes to the improvement of the planet`s ecology.',
  'Unique cyclic model': "Rent from our catalogue",
  'Description first about model':
    "Choose a dress or suit, size and rental dates. Availability and pricing are shown during booking.",
  'Description second about model':
    "You can book as a guest. With an account, your reservations and their status are available in one place.",
};
